import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TEXTS } from '../../../../core/texts';
import { TextField, useTheme } from '@mui/material';
import { Dayjs } from 'dayjs';
import { ValidationErrorState } from '../../../../types/validationErrorState';
import { useCallback, useState } from 'react';
import { Validator } from '../../../../core/Validator';
import { parseDate } from '../../../../utils/parseDate';

interface Props {
  handleDateChange: (date: string) => void,
  nextProjectStart: string,
  validationErrors: ValidationErrorState,
  disabled: boolean,
}

const NextProjectDatePicker = ({ handleDateChange, validationErrors, nextProjectStart, disabled }: Props) => {
  const theme = useTheme();
  const [lastValidDate, setLastValidDate] = useState(nextProjectStart);
  const onChange = useCallback((date: Dayjs | null) => {
    if (!date) { return; }
    handleDateChange(parseDate(date));
    if (date.isValid()) {
      setLastValidDate(parseDate(date));
    }
  }, [handleDateChange]);

  const onBlur = useCallback(() => {
    if(nextProjectStart !== lastValidDate){
      handleDateChange(lastValidDate);
    }
  }, [nextProjectStart, lastValidDate, handleDateChange]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        inputFormat={'DD/MM/YYYY'}
        PaperProps={{
          sx: {
            border: 1,
            borderColor: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius,
            '& .Mui-selected': {
              color: `${theme.palette.background.default} !important`,
              backgroundColor: `${theme.palette.primary.main} !important`
            }
          }
        }}
        disabled={disabled}
        ignoreInvalidInputs={false}
        onChange={onChange}
        value={nextProjectStart}
        label={TEXTS.NEX_PROJECT_START}
        renderInput={params =>
          <TextField {...params} error={!!validationErrors['nextProjectStart']}
                     helperText={validationErrors['nextProjectStart']} fullWidth
                     variant={disabled ? 'standard' : 'outlined'} onBlur={onBlur}
                     required={!disabled && !!Validator.LENGTHS.AVAILABILITY['nextProjectStart']?.min}
          />
        }
      />
    </LocalizationProvider>
  );
};

export default NextProjectDatePicker;